import $ from 'jquery';
import { accordion } from '../modules/containers/accordion/index';
import { initWowLibrary } from '@/scripts/helpers/initWowLibrary';

const ACTIVE = 'is-active';
const countriesBtn = '#countries-btn';
const citiesBtn = '#cities-btn';
const countriesSelector = '#countries-group';
const citiesSelector = '#cities-group';

initWowLibrary();

const initStates = () => {
  const select = $('.states');

  select.on('click', function() {
    select.toggleClass(ACTIVE);
  });
}

const locationCount = (parent) => {
  const itemsCount = $(parent + ' .location__item').length;
  const actionLinks = $('.js-location-action');
  actionLinks.removeClass('is-hide is-hide-on-tablet is-hide-on-desktop')

  if (itemsCount <= 12) {
    actionLinks.addClass('is-hide');
    return
  }

  if (itemsCount <= 24) {
    actionLinks.addClass('is-hide-on-tablet');
    return
  }

  if (itemsCount <= 36) {
    actionLinks.addClass('is-hide-on-desktop');
  }
}

const checkLocationItems = () => {
  if ($(countriesBtn).hasClass(ACTIVE)) locationCount(countriesSelector);
  if ($(citiesBtn).hasClass(ACTIVE)) locationCount(citiesSelector);
}

const initLocation = () => {
  const header = $('.location__header');
  const body = $('.location__body');
  const headerTitles = header.find('.location__title');
  const bodyGroups = body.find('.location__group');

  const handleClick = function () {
    const index = $(this).index() + 1;

    headerTitles.removeClass(ACTIVE);
    bodyGroups.removeClass(ACTIVE);
    $(this).addClass(ACTIVE)
    $('.location__body .location__group:nth-child(' + index + ')').addClass(ACTIVE);
    checkLocationItems();
  };

  headerTitles.click(handleClick);
  checkLocationItems();
}

const showLocation = () => {
  $('.js-section-location').toggleClass('is-open');
}

$(document).ready(() => {
  accordion();
  initStates();
  initLocation();

  $('.js-details-show, .js-details-hide').on('click', showLocation);
});

window.$ = $;
window.jquery = $;
window.jQuery = $;
